import { createContext } from "react";

const DirectionsContext = createContext();

export default DirectionsContext;
